import {PromoAdvice} from 'types';
import {ShoppingDataLayerShippingInfo} from 'types/recommedation-types/recommendations';

import {CarouselAnalyticsProps} from '../carousel-list-container/types';

export type ProductCardProps = {
  itemIndex: number;
  carouselAnalyticsProps?: CarouselAnalyticsProps;
  sendCarouselImpressionAnalytics: () => void;
  product: any;
  isSearchBoxCarousel?: boolean;
  carouselIndex: number;
};

type ShoppingDataLayerDeliveryDescription = {
  singleLine: string;
  singleLineV2: string;
  summary: string;
  summaryV2: string;
  popup: string;
  popupV2: string;
};

export enum ShippingFlag {
  EXPRESS_DELIVERY = 'EXPRESS_DELIVERY',
  IS_1PX = 'IS_1PX',
  BULKY_1P = 'BULKY_1P',
  BULKY_3P = 'BULKY_3P',
  SAME_DAY_1P = 'SAME_DAY_1P',
  NEXT_DAY_1P = 'NEXT_DAY_1P',
  SLOTS_3P = 'SLOTS_3P',
  DROPSHIP_3P = 'DROPSHIP_3P',
  PRE_ORDER = 'PRE_ORDER'
}

export type DeliveryInfoType = {
  shippingFlag: ShippingFlag;
  deliveryIn24Hrs?: boolean;
  shippingInfo?: ShoppingDataLayerShippingInfo[];
  deliveryDescription?: ShoppingDataLayerDeliveryDescription;
};

export type PromotionsMap = Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}>;
